import { Page } from '@/core/architecture'

import { GlobalCollectionsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * GlobalCollections Page
 * Implemented as a practical sample.
 */
export const GlobalCollections: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <GlobalCollectionsTemplate
      state={state}
      onFetchMore={actions.onFetchMore}
    />
  )
}
